import styled from 'styled-components';

import { Container } from '@xing-com/layout-primitives';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceXXL } from '@xing-com/tokens';

export const NativeAdContainer = styled(Container)`
  margin-top: ${spaceXXL};
`;

export const AdsContainer = styled(Container)`
  justify-content: center;
  display: flex;
  min-height: 90px;

  @media ${mediaSmallOrTiny} {
    min-height: 0;
  }

  section {
    display: block;
  }
`;
